import Banner from "../../components/privacyPolicy/banner";
const PrivacyPolicy = () => {
  return (
    <div>
      <Banner />
    </div>
  );
};
export default PrivacyPolicy;
